import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import Badge from "../../../components/Common/Badge/Badge";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

function CnaeDataTable({ linhas, togCnaeModal, apagarRelacionamento }) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Código CNAE",
        accessor: "cnae",
        isSorted: true,
      },
      {
        Header: "Descrição CNAE",
        accessor: "cnae_descricao",
      },
      {
        Header: "Item de serviço",
        accessor: "item_servico",
      },
      {
        Header: "Descrição item de serviço",
        accessor: "item_descricao",
      },
      {
        Header: "Anexos",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];
          const anexos = JSON.parse(row.original.anexos);

          anexos &&
            anexos.map((anexo) =>
              status.push(
                <div>
                  <Badge color="success">{anexo}</Badge>
                </div>
              )
            );

          return status;
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`excluir-${row.original.id}`}
                onClick={() => {
                  apagarRelacionamento(row.original.id);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [apagarRelacionamento]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded
          onClick={() => {
            togCnaeModal();
          }}
          color="success"
          icon={<FaPlus />}
        >
          Novo relacionamento
        </ButtonRounded>
      }
    />
  );
}

CnaeDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  togCnaeModal: PropTypes.func.isRequired,
  apagarRelacionamento: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default CnaeDataTable;
